// Глобальный стор для переключения активного заведения в админ-панели.
// ADMIN/OWNER может работать с любым из существующих заведений — id выбранного
// шлётся в каждом запросе в заголовке X-Establishment-Id. Бэкенд, видя этот
// заголовок и роль ADMIN/OWNER, использует переданный id вместо того, что
// зашит в JWT. Значение хранится в localStorage и переживает перезагрузку.

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type EstablishmentState = {
  currentId: string | null;
  isHydrated: boolean;
  setCurrentId: (id: string | null) => void;
};

export const useEstablishmentStore = create<EstablishmentState>()(
  persist(
    (set) => ({
      currentId: null,
      isHydrated: false,
      setCurrentId: (id) => set({ currentId: id }),
    }),
    {
      name: 'resstro_admin_current_establishment',
      onRehydrateStorage: () => (state) => {
        if (state) state.isHydrated = true;
      },
    },
  ),
);
